import { render, staticRenderFns } from "./ImageUploadForm.vue?vue&type=template&id=4bbb9c10&scoped=true"
import script from "./ImageUploadForm.vue?vue&type=script&lang=js"
export * from "./ImageUploadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbb9c10",
  null
  
)

export default component.exports